import React, { useCallback, useState } from 'react'
import { Error, IconButton } from 'components/Form'
import { Label } from 'components/Form'
import { WrapField, WrapFieldContent, TextFieldStyles } from './Styled'
import { InputAdornment, SvgIcon, TextField } from '@mui/material'
import { ReactComponent as Visibility } from 'assets/icons/Visibility.svg';
import { ReactComponent as VisibilityOff } from 'assets/icons/VisibilityOff.svg';
import './style.css'

//Render input field
const Input = (props) => {
    const { isLocked, disabled, onKeyDown, rows = 1, autocomplete, startAdornment, endAdornment, required, label, name, input, type, placeholder, className, gridArea, arrayIndex, mandatory } = props,
        { onChange, value = null } = input

    const [showPassword, setShowPassword] = useState(type === 'password')

    const _onChange = useCallback((e) => {
        onChange(e.target.value);
    }, [onChange])

    return (
        <WrapField className={className} style={arrayIndex ? { gridArea: `${gridArea}_${arrayIndex}` } : {}}>
            <WrapFieldContent>
                {label && <Label label={label} mandatory={mandatory} />}
                <TextFieldStyles
                    id="outlined-basic"
                    disabled={isLocked || disabled}
                    onKeyDown={onKeyDown}
                    size='small'
                    name={name}
                    color="thirdly"
                    value={isLocked ? "xxxxxx" : value}
                    autocomplete={autocomplete}
                    type={isLocked ? "password" : (showPassword ? "password" : "text")}
                    onChange={_onChange}
                    label={`${required ? "*" : ""}${placeholder}`}
                    multiline={rows > 1}
                    rows={rows}
                    variant="outlined"
                    inputProps={{
                        autocomplete: autocomplete,
                    }}
                    InputProps={{
                        endAdornment: (
                            endAdornment ?
                                <InputAdornment position="end">
                                    <endAdornment.component {...props} />
                                </InputAdornment> :
                                type != 'password' ||
                                <InputAdornment position="end">
                                    <IconButton

                                        hideFill
                                        aria-label="toggle password visibility"
                                        action={() => setShowPassword(!showPassword)}
                                        edge="end"
                                        icon={
                                            <SvgIcon fontSize="small" component={showPassword ? Visibility : VisibilityOff} color="black" inheritViewBox />
                                        }
                                    />
                                </InputAdornment>
                        ),
                        startAdornment: (
                            startAdornment &&
                            <InputAdornment position="end">
                                <startAdornment.component {...props} />
                            </InputAdornment>
                        )
                    }}
                // hiddenlabel="true"
                // placeholder={placeholder}
                />
            </WrapFieldContent>
            <Error {...props} />
        </WrapField>
    )
}

export default Input